import React from "react";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export default function Collapsed(props) {
  const [showCollapsed, setShowCollapsed] = React.useState(false);

  return (<div>
    <div
      style={{
        marginBottom: 10,
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={() => setShowCollapsed(!showCollapsed)}
    >
      {/* Заголовок и стрелка по одной линии: без flex-выравнивания крупная
          иконка уводила текст с базовой линии (пункт 74 QA-таблицы). */}
      <span>{props.title}</span>
      {showCollapsed ? (
        <ExpandLess fontSize="large" />
      ) : (
        <ExpandMore fontSize="large" />
      )}
    </div>

    <Collapse in={showCollapsed} timeout="auto">{props.content}</Collapse>
  </div>);
}
